export default __webpack_public_path__ + "f75f93674d6396bcf7ed0546a37b6139.png";